module.exports = __webpack_public_path__ + "static/media/tmc40.b71f4801.png";